import Image from 'next/legacy/image';
import React from 'react';
import FigureLogo from 'pages/figure/Logo_HELOC_stacked_Purple.png';
import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import BlueOnWhiteLogo from 'components/Logo/BlueOnWhiteLogo';

// pages/index.js
import Head from 'next/head';

export default function Home() {
  return (
    <div>
      <BlueOnWhiteLogo className="w-auto h-10 sm:h-10  mx-auto" />
      <CenteredContentSection>
        <div className=" min-h-screen flex flex-col items-center mt-8 md:mt-0 md:justify-center">
          <Head>
            <title>EnergyyPal - FIGURE Partner Referral Program</title>
          </Head>
          <div className="bg-white p-8 pt-2 rounded-lg shadow-xl w-full max-w-2xl">
            <div className="text-center mb-6">
              <Image
                src={FigureLogo}
                alt="Figure Logo"
                className="mx-auto mb-4"
                width={150}
                height={60}
              />
              <h1 className="text-2xl font-semibold">
                Figure Home Equity Line
              </h1>
              <h2 className="text-sm text-gray-600">(Figure HELOC)</h2>
            </div>

            <ul className="mb-10">
              <li className="mb-2">
                Tap your home equity and get fast access to cash
              </li>
              <li className="mb-2">
                100% online application, can be completed in minutes
              </li>
              <li className="mb-2">
                See your rate in a few clicks without impacting your credit
                score*
                <br />
                <p className="text-xs mt-2 p-0 leading-tight">
                  *To check the rates and terms you qualify for, we will conduct
                  a soft credit pull that will not affect your credit score.
                  However, if you continue and submit an application, we will
                  request your full credit report from one or more consumer
                  reporting agencies, which is considered a hard credit pull and
                  may affect your credit.
                </p>
              </li>
            </ul>

            <div className="text-center">
              <a
                href="https://www.figure.com/account/heloc/register?utm_source=Partner&utm_medium=EnergyPal"
                className="bg-primary text-white text-lg px-8 py-4 rounded-full hover:bg-blue-600 focus:outline-none focus:border-blue-700 focus:ring focus:ring-blue-200 active:bg-blue-700 no-underline"
              >
                Find my rate
              </a>

              <p className="text-xs mt-10 p-0 leading-tight">
                *By clicking “Find my rate”, I am authorizing Figure to share
                with EnergyPal my contact information (including name, email,
                and phone number), as well as information regarding the status
                of my application for financing. No details regarding your
                financial profile (income data, credit score, etc.) will be
                shared by Figure. If you wish to move forward with an
                application but do not authorize Figure to share your
                information, please go directly to Figure.com.
              </p>
            </div>
          </div>
        </div>
      </CenteredContentSection>
    </div>
  );
}
